module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-bold-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-bold-webfont.woff2
// module id = 93
// module chunks = d-game